import immutable from 'immutable';
import Moment from 'moment';

const LOADMONTH = '@@Calendar/LOADMONTH';
const LOADMONTH_SUCCESS = '@@Calendar/LOADMONTH_SUCCESS';
const LOADMONTH_FAIL = '@@Calendar/LOADMONTH_FAIL';
const SET_DATE = '@@Calendar/SET_DATE';

const initialState = immutable.fromJS({
	month: {
		date: null,
		pending: false,
		data: {}
	}
});

export default function reducer(state = initialState, action = {}) {
	switch (action.type) {

		case LOADMONTH:
			return state
				.setIn(['month', 'pending'], true);

		case LOADMONTH_SUCCESS:
			return state
				.setIn(['month', 'pending'], false)
				.setIn(['month', 'data'], action.result.data);

		case LOADMONTH_FAIL:
			return state
				.setIn(['month', 'pending'], false);

		default:
			return state;
	}
}


export function load(date) {
	return {
		types: [LOADMONTH, LOADMONTH_SUCCESS, LOADMONTH_FAIL],
		promise: (client) => client.call('calendar.getMonth', {date}, {progress:false})
	};
}

export function setDate(date) {
	return {
		type: SET_DATE,
		url: '/calendar/' + Moment(date).format('YYYY-MM-DD')
	};
}



// WEBPACK FOOTER //
// ./src/redux/modules/calendar.js